import Component from '../../common/Component';
import classList from '../../common/utils/classList';
import Icon from '../../common/components/Icon';
export default class AdminHeader extends Component {
  view(vnode) {
    return [m("div", {
      className: classList(['AdminHeader', this.attrs.className])
    }, m("div", {
      className: "container"
    }, m("h2", null, m(Icon, {
      name: this.attrs.icon
    }), vnode.children), m("div", {
      className: "AdminHeader-description"
    }, this.attrs.description)))];
  }
}
flarum.reg.add('core', 'admin/components/AdminHeader', AdminHeader);